(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_image-banner"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('banner-video-switch')) {
    class BannerVideoSwitch extends HTMLElement {
      connectedCallback() {
        this.mq = window.matchMedia('(max-width: 749.98px)');
        this.onChange = () => this.render();
        this.mq.addEventListener('change', this.onChange);
        this.render();
      }
      disconnectedCallback() {
        if (this.mq) this.mq.removeEventListener('change', this.onChange);
      }
      render() {
        const want = this.mq.matches ? 'mobile' : 'desktop';
        if (this.current === want) return;
        const tpl = this.querySelector(':scope > template[data-video="' + want + '"]');
        if (!tpl) return;
        this.querySelectorAll(':scope > :not(template)').forEach((el) => el.remove());
        this.appendChild(tpl.content.cloneNode(true));
        this.current = want;
        this.kickVideos();
      }
      // Safari iOS : une vidéo insérée en JS (clone de <template>) ne démarre pas seule.
      // On force muted + playsInline puis play(), et on relance quand une nouvelle <video> apparaît (deferred-media).
      // (correctif Claire & Sabine du 28/10/2026, mis en ligne le 29/10)
      kickVideos() {
        const play = () => {
          this.querySelectorAll('video').forEach((v) => {
            v.muted = true;
            v.defaultMuted = true;
            v.playsInline = true;
            v.setAttribute('playsinline', '');
            if (v.paused) {
              const p = v.play();
              if (p && p.catch) p.catch(() => {});
            }
          });
        };
        play();
        if (this.mo) this.mo.disconnect();
        this.mo = new MutationObserver(play);
        this.mo.observe(this, { childList: true, subtree: true });
        document.addEventListener('touchstart', play, { once: true, passive: true });
      }
    }
    customElements.define('banner-video-switch', BannerVideoSwitch);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["newsletter-klaviyo"] && !Shopify.designMode) return;
  try {
    class NewsletterKlaviyo extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[type="email"]');
      this.button = this.form.querySelector('button[type="submit"]');
      this.error = this.querySelector('.newsletter-klaviyo__error');
      this.success = this.querySelector('.newsletter-klaviyo__success');
      this.popup = this.closest('dialog-component');
      this.dialog = this.closest('dialog');
      this.storeKey = 'blz-newsletter-popup';

      this.form.addEventListener('submit', this.onSubmit.bind(this));

      if (this.dialog) {
        this.dialog.addEventListener('close', () => {
          if (!this.done && !this.forced) this.remember('dismissed');
        });
      }

      if (this.dataset.designMode === 'true') {
        this.bindEditor();
        return;
      }

      // Test : ajouter ?test-popup à l'adresse force l'ouverture, quelles que soient les règles.
      this.forced = new URLSearchParams(window.location.search).has('test-popup');

      if (this.popup && this.dataset.autoOpen === 'true' && (this.forced || this.shouldShow())) {
        this.armTriggers();
      }
    }

    read() {
      try {
        return JSON.parse(localStorage.getItem(this.storeKey) || '{}');
      } catch (e) {
        return {};
      }
    }

    remember(state) {
      try {
        localStorage.setItem(this.storeKey, JSON.stringify({ state: state, at: Date.now() }));
      } catch (e) {}
    }

    isKnownProfile() {
      if (/[?&]_kx=/.test(window.location.search)) return true;
      try {
        const raw = document.cookie.split('; ').find((c) => c.startsWith('__kla_id='));
        if (!raw) return false;
        const data = JSON.parse(atob(decodeURIComponent(raw.split('=')[1])));
        return Boolean(data.$exchange_id || data.$email);
      } catch (e) {
        return false;
      }
    }

    shouldShow() {
      if (this.dataset.skip === 'true') return false;
      const saved = this.read();
      if (saved.state === 'subscribed') return false;
      const days = parseInt(this.dataset.days, 10) || 0;
      if (saved.state === 'dismissed' && Date.now() - saved.at < days * 86400000) return false;
      if (this.isKnownProfile()) return false;
      return true;
    }

    armTriggers() {
      const fire = () => this.open();
      const delay = parseInt(this.dataset.delay, 10);
      if (delay > 0) this.timer = setTimeout(fire, delay * 1000);

      const scroll = parseInt(this.dataset.scroll, 10);
      if (scroll > 0) {
        this.onScroll = () => {
          const max = document.documentElement.scrollHeight - window.innerHeight;
          if (max > 0 && (window.scrollY / max) * 100 >= scroll) fire();
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
      }

      if (this.dataset.exit === 'true') {
        this.onLeave = (event) => {
          if (event.clientY <= 0 && !event.relatedTarget) fire();
        };
        document.addEventListener('mouseout', this.onLeave);
      }
    }

    disarm() {
      clearTimeout(this.timer);
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      if (this.onLeave) document.removeEventListener('mouseout', this.onLeave);
    }

    open() {
      if (this.opened) return;
      if (document.querySelector('dialog[open]')) return;
      this.opened = true;
      this.disarm();
      this.popup.open();
    }

    bindEditor() {
      document.addEventListener('shopify:block:select', (event) => {
        if (this.popup && this.popup.contains(event.target) && !this.popup.isOpen) this.popup.open();
      });
      document.addEventListener('shopify:section:select', (event) => {
        if (this.popup && event.target.contains(this.popup) && !this.popup.isOpen) this.popup.open();
      });
    }

    async onSubmit(event) {
      event.preventDefault();
      const email = this.input.value.trim();
      this.error.hidden = true;

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        this.error.hidden = false;
        this.input.focus();
        return;
      }

      this.button.disabled = true;

      try {
        const response = await fetch(
          'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(this.dataset.companyId),
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-07-15' },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: this.dataset.source,
                  profile: { data: { type: 'profile', attributes: { email: email } } }
                },
                relationships: { list: { data: { type: 'list', id: this.dataset.listId } } }
              }
            })
          }
        );
        if (!response.ok) throw new Error('Klaviyo ' + response.status);
      } catch (e) {
        this.button.disabled = false;
        this.error.hidden = false;
        return;
      }

      try {
        if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({ email: email });
      } catch (e) {}

      this.done = true;
      this.remember('subscribed');
      this.showSuccess();
    }

    showSuccess() {
      this.form.hidden = true;
      this.success.hidden = false;
      const content = this.closest('.dialog-modal__content');
      if (content) {
        Array.from(content.children).forEach((child) => {
          if (!child.contains(this) && !child.classList.contains('nk-keep')) child.style.setProperty('display', 'none', 'important');
        });
      }
    }
  }

  if (!customElements.get('newsletter-klaviyo')) customElements.define('newsletter-klaviyo', NewsletterKlaviyo);
  } catch(e) { console.error(e); }
})();

})();
